import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { SitePagesService, siteSitePagesService } from './sitePagesService'
import { PagesServiceSideEffects } from './pagesServiceSideEffects'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(siteSitePagesService)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(SitePagesService)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(SitePagesService)
	bind(ModelUpdatesHandlersImplementor).to(PagesServiceSideEffects)
}

export const editor: ContainerModuleLoader = (bind) => {
	bind(ModelUpdatesHandlersImplementor).to(PagesServiceSideEffects)
}
